export default "__VITE_ASSET__BfIPBMI3__"